// Numeric role IDs (legacy — kept for backward compatibility)
export const REGULAR_USER = 1;
export const ORGANIZATION_ADMIN = 2;
export const ORBIT_ADMIN = 3;
export const SYS_ADMIN = 4;
export const SERVICE_LINE_ADMIN = 5;

// String-based role keys (new RBAC model)
export const ROLE_KEY = {
  REGULAR_USER: 'REGULAR_USER',
  ORGANIZATION_ADMIN: 'ORGANIZATION_ADMIN',
  ORBIT_ADMIN: 'ORBIT_ADMIN',
  SYS_ADMIN: 'SYS_ADMIN',
  SERVICE_LINE_ADMIN: 'SERVICE_LINE_ADMIN',
};

// Professional (admin) roles that can invite patients, see admin tools, etc.
const PROFESSIONAL_ROLES = [SYS_ADMIN, ORGANIZATION_ADMIN, SERVICE_LINE_ADMIN, ORBIT_ADMIN];
const PROFESSIONAL_ROLE_KEYS = [
  ROLE_KEY.SYS_ADMIN,
  ROLE_KEY.ORGANIZATION_ADMIN,
  ROLE_KEY.SERVICE_LINE_ADMIN,
  ROLE_KEY.ORBIT_ADMIN,
];

/**
 * Returns true when the user's roles array contains at least one
 * admin / professional role (works with both numeric IDs and string keys).
 */
export const isProfessional = (roles = []) =>
  roles.some(r => PROFESSIONAL_ROLES.includes(r) || PROFESSIONAL_ROLE_KEYS.includes(r));

/**
 * Returns true when the user holds only the REGULAR_USER role.
 */
export const isPublicUser = (roles = []) =>
  roles.includes(REGULAR_USER) || roles.includes(ROLE_KEY.REGULAR_USER);

/**
 * Generic check — accepts both numeric ID and string key.
 */
export const hasRole = (roles = [], role) => roles.includes(role);

// Numeric ID -> string key lookup
const ROLE_ID_TO_KEY = {
  [REGULAR_USER]: ROLE_KEY.REGULAR_USER,
  [ORGANIZATION_ADMIN]: ROLE_KEY.ORGANIZATION_ADMIN,
  [ORBIT_ADMIN]: ROLE_KEY.ORBIT_ADMIN,
  [SYS_ADMIN]: ROLE_KEY.SYS_ADMIN,
  [SERVICE_LINE_ADMIN]: ROLE_KEY.SERVICE_LINE_ADMIN,
};

/**
 * Converts a numeric role ID to its string-based RBAC key.
 */
export const roleIdToKey = (numericId) => ROLE_ID_TO_KEY[numericId];

/**
 * Converts an array of numeric role IDs to string-based RBAC keys.
 * Filters out unrecognized IDs.
 */
export const roleIdsToKeys = (roleIds = []) =>
  roleIds.map(roleIdToKey).filter(Boolean);
